import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { write } from '../language/lang';

@customElement('under-construction')
export class UnderConstruction extends LitElement {
  static styles = css`
    /* Add styles here */
    .restricted-size {
      max-height: 50vh;
      max-width: 50vw;
      width: auto;
      height: auto;
    }
  `;

  render() {
    return html`
      <div class="under-construction">
        <p>
          ${write`${'ref:underconstruction'}We're working hard to bring you this feature. Stay tuned!`}
        </p>
        <img
          src="/assets/images/under-construction.webp"
          alt="Under Construction"
          class="restricted-size"
        />
      </div>
    `;
  }
}
